/**
 * Normalizes HTML content from rich text editors by removing redundant <br> tags
 * that appear immediately after closing </p>, </ul>, or </ol> tags.
 *
 * This handles a quirk from Retool's RichTextEditor where pressing Enter twice
 * creates both a block element wrapper and a <br> tag, causing double spacing.
 *
 * The client is responsible for providing properly formatted HTML.
 * This function only removes <br> immediately after block-level closing tags
 * to prevent double spacing. Multiple consecutive <br> tags elsewhere are
 * preserved as intended by the client.
 *
 * @param html - The HTML string to normalize
 * @returns Normalized HTML string
 */
export function normalizeParagraphBreaks(html: string): string {
  if (!html) return '';

  return (
    html
      // Remove <br> immediately after </p> or </ul> or </ol> (Retool RichTextEditor quirk)
      .replace(/<\/(p|ul|ol)>\s*(<br\s*\/?>\s*)+/gi, '</$1>')
      .trim()
  );
}
